module.exports = __webpack_public_path__ + "static/media/icon-question-mark-circle.7c281e39.svg";